import { Component } from '@angular/core';

@Component({
  templateUrl: './check-box.html'  
})
export class CheckBoxComponent { 

    constructor() {
      
    }
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/check-box/check-box-component.ts